import { OpcionPedagogicaI } from "../interfaces/OpcionPedagogica";

export interface infoFetchGetOpcionPedagogicaI {
  id: number | string;
  nombre: string;
}

class OpcionPedagogica implements OpcionPedagogicaI {
  id: number | string;
  nombre: string;
  constructor(dto: infoFetchGetOpcionPedagogicaI) {
    this.id = dto.id;
    this.nombre = dto.nombre;
  }
}

export const makeOpcionPedagogica = (
  infoFetch: infoFetchGetOpcionPedagogicaI,
) => {
  return new OpcionPedagogica(infoFetch);
};
